import React from 'react';
import { MenuItem, SalvLabel, SalvMenuButton, SalvTooltipWrapper, Size } from '@salvapp/ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { InternalApiNoteDraft } from '../../../api-internal';
import { formatDate, formatTime } from '../../../common/datetime/FormattedDateTime';
import { ContentPreviewer } from '../../../common/ContentPreviewer';
import './NoteDrafts.scss';

interface NoteDraftItemProps {
  draft: InternalApiNoteDraft;
  userName?: string;
  isActiveElsewhere?: boolean;
  onEdit: (draft: InternalApiNoteDraft) => void;
  onDelete: (draft: InternalApiNoteDraft) => void;
}

export const NoteDraftItem = ({ draft, userName, isActiveElsewhere, onEdit, onDelete }: NoteDraftItemProps) => {
  const handleAction = (values: string[]) => {
    const action = values[0];
    if (action === 'edit') {
      onEdit(draft);
    } else if (action === 'delete') {
      onDelete(draft);
    }
  };

  return (
    <article className='divider p-x-24 p-y-16 note-draft-item' aria-label={`Draft note by ${userName ?? 'You'}`}>
      <div className='p-b-4' style={{ display: 'flex' }}>
        <span className='text-strong-s'>{userName ?? 'You'}</span>
        {draft.updatedTime && (
          <>
            <span className='text-strong-s no-break'>, {formatDate(draft.updatedTime)}</span>
            <span className='text-strong-s p-l-4 p-r-8 no-break'>{formatTime(draft.updatedTime)}</span>
          </>
        )}
        <SalvLabel variant='secondary' removable={false} className='draft-label'>
          Draft
        </SalvLabel>
        {isActiveElsewhere && (
          <SalvTooltipWrapper tooltip='Being edited in another tab' placement='top'>
            <FontAwesomeIcon
              icon={faTriangleExclamation}
              className='editing-elsewhere-icon'
              aria-label='Being edited in another tab'
            />
          </SalvTooltipWrapper>
        )}
        <div className='spacer' />
        <div className='draft-actions'>
          <SalvMenuButton ariaLabel='Draft actions' onAction={handleAction} size={Size.SMALL}>
            <MenuItem title='Edit' value='edit' />
            <MenuItem title='Delete' value='delete' dangerTextColor />
          </SalvMenuButton>
        </div>
      </div>
      <ContentPreviewer previewLinesAmount={3}>{draft.content}</ContentPreviewer>
    </article>
  );
};
